var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMlpCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2875 25.2699L26.8007 26.7755C26.7222 26.7237 25.235 25.7367 24.0859 25.515L26.5727 24.0094C27.7226 24.2319 29.2098 25.2189 29.2875 25.2708",
    fill: "#08091B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5274 17.3978L9.52742 17.3978C13.076 15.664 17.3955 16.0293 21.5425 18.1097C25.6866 20.1887 29.6136 23.9631 32.3165 28.9506C35.0197 33.9384 35.9682 39.1587 35.3435 43.5546C34.719 47.949 32.5329 51.4849 28.9902 53.2159C25.4416 54.9498 21.1221 54.5846 16.975 52.5042C12.8308 50.4252 8.90359 46.6506 6.20022 41.6623C3.49661 36.6736 2.54815 31.4535 3.17306 27.0581C3.79776 22.6642 5.98421 19.1288 9.5274 17.3978Z",
    fill: "url(#paint0_linear_11606_37069)",
    stroke: "url(#paint1_linear_11606_37069)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8143 28.1101L20.9665 27.6109L17.8137 24.9862L18.8143 28.1101Z",
    fill: "#CAFFCA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4013 45.5465L25.4841 45.2952L24.4749 31.3208L24.1036 31.0117L20.0473 31.9526L24.4013 45.5465Z",
    fill: "#CAFFCA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8081 29.2718L15.9604 28.7727L14.9414 25.5907L13.8081 29.2718Z",
    fill: "#CAFFCA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0821 34.0898L20.6477 46.4172L21.5456 46.2092L17.1914 32.6148L13.2561 33.5272L13.0821 34.0898Z",
    fill: "#CAFFCA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6106 32.8126L11.8957 30.58L16.846 29.4316L15.2482 24.4439L16.8485 24.0724L18.4461 29.0607L23.3964 27.9123L24.1113 30.145L19.161 31.2934L23.7726 45.6925L22.1725 46.0633L17.5609 31.6642L12.6106 32.8126Z",
    fill: "#03F5AE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9555 43.0084L28.4688 44.514C28.5923 44.4416 28.7086 44.3576 28.8161 44.263L31.3029 42.7574C31.1955 42.8522 31.0792 42.9362 30.9555 43.0084Z",
    fill: "#027F5A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2481 19.5182L8.76047 21.0238C8.73374 21.0372 8.71622 21.0472 8.70703 21.0531L11.1938 19.5475C11.203 19.5424 11.2205 19.5324 11.2481 19.519",
    fill: "#08091B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1938 19.5508L8.70703 21.0564L8.71288 21.0522L11.1996 19.5466H11.1938",
    fill: "#027F5A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3032 43.0403L14.8164 44.5459C14.8859 44.5058 14.9521 44.4602 15.0143 44.4095L17.5019 42.9039C17.4391 42.9542 17.3727 42.9998 17.3032 43.0403Z",
    fill: "#027F5A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.540894 26.6983L3.02851 25.1927V25.1918C3.87442 21.841 5.70234 19.0791 8.43964 17.4213L5.95286 18.9269C3.21306 20.5847 1.38763 23.3475 0.540894 26.6983ZM9.90849 47.715L9.90799 47.7153C8.28903 45.9578 6.89531 44.0048 5.75913 41.9017C2.63771 36.1427 1.80183 30.0501 3.02852 25.1937L0.540903 26.6993C-0.68495 31.5557 0.150931 37.6475 3.27235 43.4073C4.40836 45.5106 5.80227 47.4635 7.42171 49.2206L9.90799 47.7153L9.90802 47.7153L7.42169 49.2206C13.1334 55.3969 20.866 58.0317 26.7214 55.1719C27.0203 55.0236 27.309 54.8658 27.5873 54.6985L30.057 53.2038C29.7831 53.3692 29.5002 53.5231 29.2082 53.6655C23.3528 56.5261 15.6202 53.8905 9.90849 47.715Z",
    fill: "#4B437C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_11606_37069)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.1898,
    cy: 28.2034,
    rx: 16.2746,
    ry: 6.97484,
    transform: "rotate(53.1138 28.1898 28.2034)",
    fill: "black"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7125 9.47506L29.1993 10.9807C29.2778 10.9288 30.765 9.9418 31.9141 9.72014L29.4273 8.21454C28.2774 8.43703 26.7902 9.42404 26.7125 9.4759",
    fill: "#08091B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4726 1.60294L46.4726 1.60293C42.924 -0.130906 38.6045 0.234413 34.4575 2.31482C30.3134 4.39383 26.3864 8.16827 23.6835 13.1557C20.9803 18.1435 20.0318 23.3639 20.6565 27.7598C21.281 32.1542 23.4671 35.6901 27.0098 37.4211C30.5584 39.1549 34.8779 38.7898 39.025 36.7094C43.1692 34.6304 47.0964 30.8557 49.7998 25.8675C52.5034 20.8788 53.4518 15.6587 52.8269 11.2632C52.2022 6.86929 50.0158 3.33396 46.4726 1.60294Z",
    fill: "url(#paint2_linear_11606_37069)",
    stroke: "url(#paint3_linear_11606_37069)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1857 12.3152L35.0335 11.8161L38.1863 9.19133L37.1857 12.3152Z",
    fill: "#CAFFCA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5987 29.7517L30.5159 29.5004L31.5251 15.526L31.8964 15.2168L35.9527 16.1578L31.5987 29.7517Z",
    fill: "#CAFFCA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1919 13.4769L40.0396 12.9778L41.0586 9.79584L42.1919 13.4769Z",
    fill: "#CAFFCA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9179 18.295L35.3523 30.6223L34.4544 30.4143L38.8086 16.8199L42.7439 17.7324L42.9179 18.295Z",
    fill: "#CAFFCA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3894 17.0178L44.1043 14.7851L39.154 13.6367L40.7518 8.64904L39.1515 8.27749L37.5539 13.2659L32.6036 12.1175L31.8887 14.3501L36.839 15.4985L32.2274 29.8976L33.8275 30.2685L38.4391 15.8694L43.3894 17.0178Z",
    fill: "#03F5AE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0445 27.2135L27.5312 28.7191C27.4077 28.6468 27.2914 28.5627 27.1839 28.4682L24.6971 26.9626C24.8045 27.0573 24.9208 27.1414 25.0445 27.2135Z",
    fill: "#027F5A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7519 3.72333L47.2395 5.22893C47.2663 5.24231 47.2838 5.25235 47.293 5.2582L44.8062 3.7526C44.797 3.74758 44.7795 3.73755 44.7519 3.72416",
    fill: "#08091B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8062 3.7559L47.293 5.2615L47.2871 5.25731L44.8004 3.75171H44.8062",
    fill: "#027F5A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6968 27.2454L41.1836 28.751C41.1141 28.7109 41.0479 28.6654 40.9857 28.6147L38.4981 27.1091C38.5609 27.1593 38.6273 27.2049 38.6968 27.2454Z",
    fill: "#027F5A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.4591 10.9034L52.9715 9.39781V9.39699C52.1256 6.04618 50.2977 3.28424 47.5604 1.6264L50.0471 3.13201C52.7869 4.78984 54.6124 7.55261 55.4591 10.9034ZM46.0915 31.9201L46.092 31.9204C47.711 30.1629 49.1047 28.21 50.2409 26.1068C53.3623 20.3479 54.1982 14.2552 52.9715 9.39879L55.4591 10.9044C56.685 15.7608 55.8491 21.8526 52.7277 27.6124C51.5916 29.7157 50.1977 31.6686 48.5783 33.4257L46.092 31.9204L46.092 31.9204L48.5783 33.4258C42.8666 39.6021 35.134 42.2369 29.2786 39.3771C28.9797 39.2287 28.691 39.0709 28.4127 38.9036L25.9428 37.4088C26.2168 37.5742 26.4998 37.7282 26.7918 37.8706C32.6472 40.7313 40.3798 38.0956 46.0915 31.9201Z",
    fill: "#4B437C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_11606_37069",
    x: 8.9375,
    y: 6.52612,
    width: 38.5039,
    height: 43.3546,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_11606_37069"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11606_37069",
    x1: 19.2582,
    y1: 15.7949,
    x2: 19.2582,
    y2: 54.8189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C80EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006BA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11606_37069",
    x1: 19.2582,
    y1: 15.7949,
    x2: 19.2582,
    y2: 54.8189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE9CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F76B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11606_37069",
    x1: 36.7418,
    y1: 0,
    x2: 36.7418,
    y2: 39.0241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C80EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006BA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11606_37069",
    x1: 36.7418,
    y1: 0,
    x2: 36.7418,
    y2: 39.0241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE9CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F76B9"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMlpCoin);
export default __webpack_public_path__ + "static/media/mlp_coin.61970028bb54ea995e723154b79e3276.svg";
export { ForwardRef as ReactComponent };